import { parse } from 'qs'

export const NUMBER = /^0|([1-9]\d*)$/
export const PHONE_REGEXP = /^1[3456789]\d{9}$/

export function getPageQuery() {
  return parse(window.location.href.split('?')[1])
}

const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/

export function isUrl(path) {
  return reg.test(path)
}

export function getSecretPhone(phone) {
  if (!phone) {
    return
  }
  return phone.replace(/(\d{3})\d{4}(\d{4})/g, '$1****$2')
}

// 默认头像地址
export const DEFAULT_AVATAR_URL =
  'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1575614673388&di=9524a6095ca63e0d7f69cd8e9a795ea6&imgtype=0&src=http%3A%2F%2F5b0988e595225.cdn.sohucs.com%2Fimages%2F20170901%2Ffc6a2a3b00b54aa68f4f11174def5c75.jpeg'

export const getQueryValue = queryName => {
  const query = decodeURI(window.location.search.substring(1))
  const vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] == queryName) {
      return pair[1]
    }
  }
  return null
}
